import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import styles from '@patternfly/react-styles/css/components/Masthead/masthead.mjs';
import { css } from '@patternfly/react-styles';
export const MastheadLogo = (_a) => {
    var { children, className, component } = _a, props = __rest(_a, ["children", "className", "component"]);
    let Component = component;
    if (!component) {
        if ((props === null || props === void 0 ? void 0 : props.href) !== undefined) {
            Component = 'a';
        }
        else {
            Component = 'span';
        }
    }
    return (_jsx(Component, Object.assign({ className: css(styles.mastheadLogo, className) }, (Component === 'a' && { tabIndex: 0 }), props, { children: children })));
};
MastheadLogo.displayName = 'MastheadLogo';
//# sourceMappingURL=MastheadLogo.js.map